module.exports = __webpack_public_path__ + "images/emoji/arrow_upper_left.67355e8f782d009e4b41.png";